import type { Image3DPageFormat } from '@/formats/UnitParser';
import type { Pixel } from '@/data';
import type { Image3DPageData } from '@/data/sources';
import { pageToPageData } from '@/http-client/utils/pageToPageData';

export class StructurePageParser {
  static createNewPage(
    oldPage: Image3DPageFormat,
    pagesDimensions: { height: Pixel; width: Pixel; }[],
  ): Image3DPageData {
    const maxWidth: Pixel = this.calculateMaxWidth(oldPage);
    const totalHeight: Pixel = this.calculateTotalHeight(oldPage);

    const dimensions = { height: totalHeight as Pixel, width: maxWidth };

    pagesDimensions.push(dimensions);

    return pageToPageData(oldPage, dimensions);
  }

  private static calculateMaxWidth(page: Image3DPageFormat): Pixel {
    const widthMaxInRows = page.rows
      .map((row) => row['end-x'])
      .reduce((prev, curr) => Math.max(prev, curr));

    return widthMaxInRows as Pixel;
  }

  private static calculateTotalHeight(page: Image3DPageFormat) {
    const lastRow = page.rows.at(-1);
    const lastY = lastRow?.y || 0;
    const lastHeight = lastRow?.height || 0;

    return (lastY + lastHeight) as Pixel;
  }
}
